import React from 'react';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { FormattedMessage } from 'react-intl';

interface EulaDeclinedConfirmationProps {
    onHide: () => void;
    show: boolean;
    onConfirm: () => void;
}

const EulaDeclinedConfirmation: React.FC<EulaDeclinedConfirmationProps> = ({ onHide, show, onConfirm }) => {
    const content = (
        <div className='text-center'>
            <div className='margin-50'>
                <div className='text-size-h4 margin-bottom-10'>
                    <FormattedMessage id='intl-msg:eulaDeclined.dialogTitle' />
                </div>
                <div className='text-size-14 text-color-warning'>
                    <span className='uikit-icon icon-warning-sign margin-right-10'/>
                    <FormattedMessage id='intl-msg:eulaDeclined.dialogPrompt'/>
                </div>
            </div>
            <div className='pull-right btn-toolbar'>
                <button type='button' className='btn btn-default' onClick={onHide}>
                    <FormattedMessage id='intl-msg:cancel'/>
                </button>
                <button type='button' className='btn btn-primary' onClick={onConfirm}>
                    <FormattedMessage id='intl-msg:proceed'/>
                </button>
            </div>
        </div>
    );

    return (
        <Dialog
            className='eula-declined-confirmation-dialog'
            show={show}
            onClose={onHide}
            useOverflow
            body={content}
        />
    );
};

export default EulaDeclinedConfirmation;
